import { createActions, createReducer } from 'reduxsauce'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    removeAdministracaoConsultaAdiantamentosSuprimentos: ['administracao'],
    removePeriodoUtilizacaoInicialConsultaAdiantamentosSuprimentos: ['periodoUtilizacaoInicial'],
    removePeriodoUtilizacaoFinalConsultaAdiantamentosSuprimentos: ['periodoUtilizacaoInicial'],
    removeNomeConsultaAdiantamentosSuprimentos: ['nome'],
    removeDocumentoConsultaAdiantamentosSuprimentos: ['documento'],
    removeStatusConsultaAdiantamentosSuprimentos: [],
    setMostraAplicarFiltroConsultaAdiantamentosSuprimentos: [],
    limpaFiltroConsultaAdiantamentosSuprimentos: [],
    aplicarFiltroConsultaAdiantamentosSuprimentos: ['filtro'],
})

const INITIAL_STATE = {
    exercicio: '',
    administracao: '',
    periodoUtilizacaoInicial: '',
    periodoUtilizacaoFinal: '',
    nome: '',
    documento: '',
    mostraAplicarFiltro: false,
    status: '',
}

const removeAdministracao = (state = INITIAL_STATE, action) => {
    state.administracao.splice(state.administracao.indexOf(action.administracao), 1)
    state.administracao = Array.from(state.administracao)
    return { ...state, mostraAplicarFiltro: true }
}

const removePeriodoUtilizacaoInicial = (state = INITIAL_STATE, action) => {
    return { ...state, periodoUtilizacaoInicial: '', mostraAplicarFiltro: true }
}

const removePeriodoUtilizacaoFinal = (state = INITIAL_STATE, action) => {
    return { ...state, periodoUtilizacaoFinal: '', mostraAplicarFiltro: true }
}

const removeNome = (state = INITIAL_STATE, action) => {
    return { ...state, nome: '', mostraAplicarFiltro: true }
}

const removeDocumento = (state = INITIAL_STATE, action) => {
    return { ...state, documento: '', mostraAplicarFiltro: true }
}

const setMostraAplicarFiltro = (state = INITIAL_STATE, action) => {
    return { ...state, mostraAplicarFiltro: !state.mostraAplicarFiltro }
}

const removeStatus = (state = INITIAL_STATE, action) => {
    return { ...state, status: '', mostraAplicarFiltro: true }
}

const aplicarFiltro = (state = INITIAL_STATE, action) => {
    action.filtro.mostraAplicarFiltro = false
    return action.filtro
}

const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.REMOVE_ADMINISTRACAO_CONSULTA_ADIANTAMENTOS_SUPRIMENTOS]: removeAdministracao,
    [Types.REMOVE_PERIODO_UTILIZACAO_INICIAL_CONSULTA_ADIANTAMENTOS_SUPRIMENTOS]: removePeriodoUtilizacaoInicial,
    [Types.REMOVE_PERIODO_UTILIZACAO_FINAL_CONSULTA_ADIANTAMENTOS_SUPRIMENTOS]: removePeriodoUtilizacaoFinal,
    [Types.REMOVE_NOME_CONSULTA_ADIANTAMENTOS_SUPRIMENTOS]: removeNome,
    [Types.REMOVE_DOCUMENTO_CONSULTA_ADIANTAMENTOS_SUPRIMENTOS]: removeDocumento,
    [Types.SET_MOSTRA_APLICAR_FILTRO_CONSULTA_ADIANTAMENTOS_SUPRIMENTOS]: setMostraAplicarFiltro,
    [Types.REMOVE_STATUS_CONSULTA_ADIANTAMENTOS_SUPRIMENTOS]: removeStatus,
    [Types.LIMPA_FILTRO_CONSULTA_ADIANTAMENTOS_SUPRIMENTOS]: limpaFiltro,
    [Types.APLICAR_FILTRO_CONSULTA_ADIANTAMENTOS_SUPRIMENTOS]: aplicarFiltro,
})
